import { EGDSLayoutPosition } from '@egds/react-core/layout-position';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyGallery, PropertyGallerySplitted } from '@shared-ui/lodging-property-details';
import { ProductGallery } from '@shared-ui/retail-product-gallery';
import { useStoredPdpImageAndPropertyName } from '../../property-details/use-stored-pdp-image-and-property-name';
import { SharedUiPropertySearchLinkWrapper } from 'components/infosite/shared-ui/offers/property-search-link-wrapper';
import { SharedUiSaveTripItemWrapper } from 'components/infosite/shared-ui/details/save-trip-item-wrapper';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
import { IdentifierType } from 'src/common/__generated__/api';
export const GalleryWrapper = ({
  inputs
}) => {
  var _a;
  const images = (_a = useStoredPdpImageAndPropertyName(inputs.propertyId)) === null || _a === void 0 ? void 0 : _a.images;
  const memoizedImages = React.useMemo(() => ({
    images
  }), [images]);
  const productGalleryInputs = React.useMemo(() => ({
    productIdentifier: {
      id: inputs.propertyId,
      type: IdentifierType.PROPERTY_ID,
      travelSearchCriteria: {
        property: inputs.searchCriteria
      }
    }
  }), [inputs.propertyId, inputs.searchCriteria]);
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Image_Mosaic_no_harm_test"
  }, React.createElement(ExperimentControl, null, React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSLayoutPosition, {
    type: "relative",
    position: {
      zindex: 'layer1'
    }
  }, React.createElement(PropertyGallery, {
    inputs: inputs,
    placeholderData: memoizedImages,
    SharedUiPropertySearchLinkWrapper: SharedUiPropertySearchLinkWrapper,
    SharedUiSaveTripItemWrapper: SharedUiSaveTripItemWrapper,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSLayoutPosition, {
    type: "relative",
    position: {
      zindex: 'layer1'
    }
  }, React.createElement(PropertyGallerySplitted, {
    inputs: inputs,
    placeholderData: memoizedImages,
    SharedUiPropertySearchLinkWrapper: SharedUiPropertySearchLinkWrapper,
    SharedUiSaveTripItemWrapper: SharedUiSaveTripItemWrapper,
    skipSsr: cSRPropertyDetailsQuery
  }))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSLayoutPosition, {
    type: "relative",
    position: {
      zindex: 'layer1'
    }
  }, React.createElement(ProductGallery, {
    inputs: productGalleryInputs,
    placeholderData: images,
    skipSsr: cSRPropertyDetailsQuery
  }))));
};
export const SharedUiGalleryWrapper = withSharedUiPropertyDetails(GalleryWrapper);
SharedUiGalleryWrapper.displayName = 'SharedUiGalleryWrapper';